import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Service from '../../../../../services/clientmanagement.service';
import ViewDetailsComponent from './../../../../../../shared/components/viewdetails';
import moment from 'moment';
import Util from './../../../../../../shared/util/util'

export default {
	name: 'ClientLog',
	components: {
		VueElementLoading,
		ViewDetailsComponent
	},
	props: ['selectBusinessAccId'],
	data() {
		return {
			isLoading : false,
			tableColumn : [],
			getLogsList : [],
		}
	},
	computed: {},
	async mounted() {
		await this.getApprovalLogsList();
	},
	methods: {
		format_date(value){
		 if (value) {
				return Util.displayDateTimeFormat(value);
			}
		},
		async getApprovalLogsList(){
			let payload = {
				clientID : this.selectBusinessAccId,
				objectType : 'client'
			}
			this.isLoading = true;
			let result = await Service.getApprovalLogAgainObjectID(payload);
			this.isLoading = false;
			this.getLogsList = result.data.data;
		}
	},
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/client/clientlisting/clienteview/clientlog/clientlog.component.js